import React from "react";

import { Dialog, Headline, Paragraph } from "@fronterahealth/frontera-ui-components";

import { LoadingProgressBar } from "@components/LoadingProgressBar/LoadingProgressBar";

interface ProgrammingReviewWelcomeDialogProps {
  isOpen: boolean;
  clientName: string;
  isLoading: boolean;
  isPending: boolean;
  canStartReview: boolean;
  hasReport: boolean;
  error: string | null;
  onStart: () => void;
  onCancel: () => void;
}

export const ProgrammingReviewWelcomeDialog: React.FC<ProgrammingReviewWelcomeDialogProps> = ({
  isOpen,
  clientName,
  isLoading,
  isPending,
  canStartReview,
  hasReport,
  error,
  onStart,
  onCancel,
}) => {
  const getButtonText = () => {
    if (isPending) return "Converting...";
    if (isLoading) return "Loading...";
    return "Start Program Review";
  };

  return (
    <div className="w-full h-full flex flex-col">
      <div className="w-full border-b border-limestone-200 px-8 py-4 bg-white">
        <Headline size="medium" colorType="primary" className="ph-no-capture">
          {clientName ? `${clientName}'s Programming Review` : "Programming Review"}
        </Headline>
      </div>

      <div className="flex-1 flex items-center justify-center bg-gray-50">
        <Dialog
          open={isOpen}
          setOpen={() => {}}
          title="Welcome to Program Review"
          size="3xl"
          showCloseButton={false}
          primaryButton={{
            text: getButtonText(),
            onClick: onStart,
            disabled: !canStartReview || isPending,
          }}
          secondaryButton={{
            text: "Cancel",
            onClick: onCancel,
            disabled: isPending,
          }}
          // tertiaryButton={{
          //   text: "Learn More", PENDING HUBSPOT LINK
          //   onClick: () => {
          //     // TODO: Handle learn more action
          //   },
          // }}
          overflowBehavior="hidden"
        >
          <div className="flex flex-col gap-4">
            <Paragraph size="medium" colorType="primary">
              Program Review is where you prepare and confirm programming before it&apos;s sent to your EHR. Here, you
              can review goals from the Initial Assessment, confirm targets and data collection, and make any final
              adjustments.
            </Paragraph>
            <Paragraph size="medium" colorType="secondary">
              Nothing is sent to your EHR until you choose to sync.
            </Paragraph>

            {error && (
              <Paragraph size="medium" colorType="primary">
                {error}
              </Paragraph>
            )}

            {!isLoading && !hasReport && (
              <Paragraph size="medium" colorType="primary">
                No initial assessment report found for this learner. Please complete an initial assessment first.
              </Paragraph>
            )}

            {(isPending || isLoading) && (
              <div className="w-full">
                <LoadingProgressBar durationInSeconds={3} isActive={true} />
              </div>
            )}
          </div>
        </Dialog>
      </div>
    </div>
  );
};
